export default __webpack_public_path__ + "static/media/venueIcon.70477166.svg";